import {type FC, useMemo} from 'react';
import {COLUMN_CRUMB, HOME_CRUMB} from '../../../../../config/constants/crumb';
import {HOME} from '../../../../../config/constants/routes';
import type {GetColumnsByCompany} from '../../../../../core/repositories/columnRepository';
import type {GetCompanyInfoResponse} from '../../../../../core/repositories/companiesRepository';
import type {Breadcrumb} from '../../../../../shared/components/BreadcrumbsComponent';
import {Card} from '../Card';
import {Header} from '../Header';
import {COLUMNS_BY_COMPANY, COLUMNS_COMPANY_LIST, COLUMNS_TOP} from '../routes';

type Props = {
  columns: GetColumnsByCompany;
  company: GetCompanyInfoResponse;
};
export const ColumnListByCompanyPage: FC<Props> = ({company, columns}) => {
  const breadcrumbs: Breadcrumb[] = useMemo(
    () => [
      {label: HOME_CRUMB, href: HOME},
      {label: COLUMN_CRUMB, href: COLUMNS_TOP},
      {label: '企業一覧', href: COLUMNS_COMPANY_LIST()},
      {
        label: company.name,
        href: COLUMNS_BY_COMPANY(company.id),
      },
    ],
    [company],
  );

  const flattenColumns = useMemo(() => {
    return [
      ...columns.nativeAd.nativeAdsPosts,
      ...columns.companyPage.companyPagePosts,
    ];
  }, [columns]);

  const title = `${company.name}のコラム`;
  return (
    <>
      <Header
        breadcrumbs={breadcrumbs}
        title={title}
        description={`${company.name}に関するコラムまとめ`}
      />
      {flattenColumns.length > 0 ? (
        <div className="w-full pc:w-[1200px] pc:mx-auto grid grid-cols-1 pc:grid-cols-3 mt-12 p-16 pc:px-0 gap-16 pc:gap-24">
          {flattenColumns.map((column) => (
            <Card
              key={column.id}
              id={column.id}
              title={column.title}
              clipCount={column.favoriteCount}
              isClipped={column.favorited}
              tagNames={column.tags}
              thumbnail={column.cardImageURL ?? column.carouselThumbnailURL}
              className="w-full"
              sponsoredOption={{enabled: false}}
              updatedAt={column.updateDateTime}
            />
          ))}
        </div>
      ) : (
        <div className="py-48 text-black-1">コラムが見つかりませんでした</div>
      )}
    </>
  );
};
